<template>
  <v-main>
    <!-- Provides the application the proper gutter -->
    <v-container fluid>
      <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>

      <!-- If using vue-router -->
      <!-- <router-view></router-view> -->
      <v-card>
        <v-card-title>
          Spesialisasi
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Cari spesialisasi"
            single-line
            hide-details
            v-on:keyup.enter="getDataFromApi"
          ></v-text-field>
          <v-spacer></v-spacer>

          <v-dialog
            v-model="dialog"
            persistent
            max-width="600px"
          >
            <template v-slot:activator="{ }">
              <v-btn
                color="primary"
                dark
                @click="doAdd"
              >
                Tambah
              </v-btn>
            </template>
            <v-card>
              <v-card-title>
                <span class="text-h5">Spesialisasi</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12">
                      <v-combobox
                        label="Profesi"
                        clearable
                        dense
                        outlined
                        v-model="selectedProfesi"
                        :items="items_profesi"
                        item-text="value"
                      ></v-combobox>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                        label="Nama"
                        required
                        v-model="spesialisasiData.nama"
                      ></v-text-field>
                    </v-col>

                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="blue darken-1"
                  text
                  @click="dialog = false"
                >
                  Close
                </v-btn>
                <v-btn
                  color="blue darken-1"
                  text
                  @click="doSave"
                >
                  Save
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-dialog
            v-model="dialogDelete"
            max-width="500px"
          >
            <v-card>
              <v-card-title class="text-h5">Apa anda akan menghapus data ini?</v-card-title>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="blue darken-1"
                  text
                  @click="closeDelete"
                >Tidak</v-btn>
                <v-btn
                  color="blue darken-1"
                  text
                  @click="deleteItemConfirm"
                >Ya</v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-card-title>
        <v-data-table
          :headers="headers"
          :items="list_data"
          :options.sync="options"
          :server-items-length="totalData"
          :loading="loading"
          class="elevation-1"
        >
          <template v-slot:[`item.actions`]="{ item }">
            <v-icon
              medium
              class="mr-3"
              @click="editItem(item)"
            >
              mdi-pencil
            </v-icon>
            <!-- <v-icon
              medium
              @click="deleteItem(item)"
            >
              mdi-delete
            </v-icon> -->
          </template>
        </v-data-table>
      </v-card>
    </v-container>
  </v-main>
</template>

<script>
import SpesialisasiService from "../services/SpesialisasiService";
import UserService from "../services/UserService";

export default {
  data: () => ({
    breadcrumbs: [
      {
        text: "Data Spesialisasi",
        disabled: true,
        href: "breadcrumbs_dashboard",
      },
    ],
    search: "",
    headers: [
      {
        text: "No",
        align: "start",
        sortable: false,
        value: "no",
      },
      { text: "Spesialisasi", value: "nama", sortable: false },
      { text: "Profesi", value: "profesi_nama", sortable: false },
      { text: "Actions", value: "actions", sortable: false },
    ],
    isFirst: false,
    totalData: 0,
    list_data: [],
    loading: true,
    options: {
      itemsPerPage: 5,
    },

    editedIndex: -1,
    editedItem: {},
    dialog: false,
    dialogDelete: false,
    spesialisasiData: {
      ID: null,
      nama: "",
    },
    selectedProfesi: "",
    items_profesi: [],
  }),
  watch: {
    options: {
      handler() {
        if (this.isFirst) {
          this.getDataFromApi();
        }
      },
      deep: true,
    },
  },
  mounted() {
    this.getDataFromApi();
    this.getListProfesi();
  },
  methods: {
    async getListProfesi() {
      UserService.profesiList()
        .then((res) => {
          this.items_profesi = res.data.list_data;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    getDataFromApi() {
      const { page, itemsPerPage } = this.options;

      this.loading = true;
      SpesialisasiService.spesialisasiList(page, itemsPerPage, this.search)
        .then((res) => {
          this.list_data = res.data.list_data;
          console.log(this.list_data);
          this.totalData = res.data.total;
          this.loading = false;
          this.isFirst = true;
        })
        .catch((err) => {
          this.loading = false;
          this.isFirst = true;
          console.log(err);
        });
    },

    doAdd: async function () {
      this.dialog = true;
      this.spesialisasiData.profesi_id = "";
      this.spesialisasiData.nama = "";
      this.spesialisasiData.ID = null;
      console.log("do add");
    },

    doSave: async function () {
      console.log(this.spesialisasiData.ID);
      if (this.spesialisasiData.ID == null) {
        if (this.selectedProfesi && this.selectedProfesi != undefined) {
          this.spesialisasiData.profesi_id = this.selectedProfesi.code;
        }

        SpesialisasiService.create(this.spesialisasiData)
          .then((res) => {
            console.log(res);
            this.dialog = false;

            this.$toast.success("Tambah spesialisasi berhasil", {
              position: "top-right",
              timeout: 5000,
              closeOnClick: true,
              pauseOnFocusLoss: true,
              pauseOnHover: true,
              draggable: true,
              draggablePercent: 0.6,
              showCloseButtonOnHover: false,
              hideProgressBar: true,
              closeButton: "button",
              icon: true,
              rtl: false,
            });

            this.getDataFromApi();
          })
          .catch((err) => {
            console.log(err);
            this.$toast.error("Tambah spesialisasi gagal. Coba lagi", {
              position: "top-right",
              timeout: 5000,
              closeOnClick: true,
              pauseOnFocusLoss: true,
              pauseOnHover: true,
              draggable: true,
              draggablePercent: 0.6,
              showCloseButtonOnHover: false,
              hideProgressBar: true,
              closeButton: "button",
              icon: true,
              rtl: false,
            });
          });
      } else {
        if (this.selectedProfesi && this.selectedProfesi != undefined) {
          this.spesialisasiData.profesi_id = this.selectedProfesi.code;
        }

        SpesialisasiService.update(
          this.spesialisasiData.ID,
          this.spesialisasiData
        )
          .then((res) => {
            this.dialog = false;

            console.log(res);
            this.$toast.success("Update spesialisasi berhasil", {
              position: "top-right",
              timeout: 5000,
              closeOnClick: true,
              pauseOnFocusLoss: true,
              pauseOnHover: true,
              draggable: true,
              draggablePercent: 0.6,
              showCloseButtonOnHover: false,
              hideProgressBar: true,
              closeButton: "button",
              icon: true,
              rtl: false,
            });

            this.getDataFromApi();
          })
          .catch((err) => {
            console.log(err);
            this.$toast.error("Update spesialisasi gagal. Coba lagi", {
              position: "top-right",
              timeout: 5000,
              closeOnClick: true,
              pauseOnFocusLoss: true,
              pauseOnHover: true,
              draggable: true,
              draggablePercent: 0.6,
              showCloseButtonOnHover: false,
              hideProgressBar: true,
              closeButton: "button",
              icon: true,
              rtl: false,
            });
          });
      }
    },

    editItem(item) {
      console.log(item);
      this.editedIndex = this.list_data.indexOf(item);
      this.editedItem = Object.assign({}, item);

      this.dialog = true;
      this.spesialisasiData.nama = this.editedItem.nama;
      this.spesialisasiData.ID = this.editedItem.id;
      this.spesialisasiData.profesi_id = this.editedItem.profesi_id;

      if (this.spesialisasiData.profesi_id) {
        this.items_profesi.forEach((entry) => {
          if (entry.code == this.spesialisasiData.profesi_id) {
            this.selectedProfesi = entry;
          }
        });
      }
    },

    deleteItem(item) {
      console.log(item);
      this.editedIndex = this.list_data.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    deleteItemConfirm() {
      this.closeDelete();

      SpesialisasiService.delete(this.editedItem.id)
        .then((res) => {
          console.log(res);
          this.$toast.success("Hapus spesialisasi berhasil", {
            position: "top-right",
            timeout: 5000,
            closeOnClick: true,
            pauseOnFocusLoss: true,
            pauseOnHover: true,
            draggable: true,
            draggablePercent: 0.6,
            showCloseButtonOnHover: false,
            hideProgressBar: true,
            closeButton: "button",
            icon: true,
            rtl: false,
          });

          this.getDataFromApi();
        })
        .catch((err) => {
          console.log(err);
          this.$toast.error("Hapus spesialisasi gagal. Coba lagi", {
            position: "top-right",
            timeout: 5000,
            closeOnClick: true,
            pauseOnFocusLoss: true,
            pauseOnHover: true,
            draggable: true,
            draggablePercent: 0.6,
            showCloseButtonOnHover: false,
            hideProgressBar: true,
            closeButton: "button",
            icon: true,
            rtl: false,
          });
        });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
  },
};
</script>
